import React, { FC } from "react";
import dummyImage from "assets/images/common/others/minorImage.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";

interface Props {
  user: any;
}

const PersonalInformation: FC<Props> = ({ user }) => {
  const navigate = useNavigate();
  console.log(user);
  const goToAttendeeDetail = () => {
    if (user?.profiles?.child?.attendeeId) {
      navigate(`${siteRoutes.attendeeView}?id=${user?.profiles?.child?.attendeeId}`);
    }
  };


  return (
    <div className="">
      <div className="my-8 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            First Name
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.firstName || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Last Name
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.lastName || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Date of Birth
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.dob || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Gender</span>
          <span className="text-xs text-tertiaryText">{user?.user?.gender || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Interest
          </span>
          <div className="flex flex-wrap gap-2">
            {user?.profiles?.child?.interest?.length
              ? user.profiles.child.interest.map((item: any, index: number) => (
                <span
                  className="text-xs bg-gray-200 px-2 py-1 rounded"
                  key={index}
                >
                  {item.replaceAll("_", " ")}
                </span>
              ))
              : "-"}
          </div>

        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Skill Level
          </span>
          <span className="text-xs text-tertiaryText"><span>
            {user?.profiles?.child?.skillLevel
              ? user.profiles.child.skillLevel.replaceAll("_", " ").replaceAll("-", " ")
              : "-"}
          </span>
          </span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Languages
          </span>
          <div className="flex flex-wrap gap-2">
            <span className="text-xs bg-gray-200 px-2 py-1 rounded">
              {user?.user?.language || "-"}
            </span>
          </div>
        </div>
      </div>

      <div className=" my-6">
        <h1 className="text-base font-bold text-primaryText">Parent Profile</h1>
        <div className="mt-4 flex flex-wrap sm:gap-40 items-center gap-4">
          <div className="flex flex-col gap-2">
            <span
              className="flex gap-3 items-center cursor-pointer"
              onClick={goToAttendeeDetail}
            >
              <img
                className="w-10 h-10 rounded-full"
                src={
                  user?.profiles?.child?.attendee?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      user?.profiles?.child?.attendee?.profilePicUrl?.fileDownloadUri
                    )
                    : editProfilePicUser
                }
                alt="Attendee"
              />
              <p className="text-base font-bold text-primaryText">
                {user?.profiles?.child?.attendee?.firstName || "-"}{" "}
                {user?.profiles?.child?.attendee?.lastName || ""}
              </p>
            </span>
            <span className="text-xs text-tertiaryText">
              {user?.profiles?.child?.attendee?.lastName || "Family"} Family
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
